import script from "./returnPage.vue?vue&type=script&setup=true&lang=js"
export * from "./returnPage.vue?vue&type=script&setup=true&lang=js"

import "./returnPage.vue?vue&type=style&index=0&id=fa177494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa177494"]])

export default __exports__